<template>
  <div
    v-if="!removeFromDOM"
    class="jfpc"
    :class="themeClass"
    :publisher-component-id="id"
    :publisher-component-placement="componentPlacement"
    :instance-id="instanceId"
  >

    <div :id="containerId" v-show="!loading" class="mediaalpha-container" :class="{ '--no-description-toggle': noDescriptionToggle }"></div>

    <div v-if="loading" class="flex justify-center grid gap-4 grid-cols-1">
      <tw-card v-for="i in (numAds > 0 ? numAds : 4)" :key="i + '_ad'" :ref="'autoInsuranceAdsAdSkeleton_' + i">
        <div class="animate-pulse flex-col space-y-4">
          <div class="w-full">
            <div class="h-3 bg-gray-300 rounded w-full" />
          </div>
          <div class="flex flex-nowrap items-center space-x-4">
            <div class="w-5/12">
              <div class="h-16 bg-gray-300 rounded w-full" />
            </div>
            <div class="w-7/12">
              <div class="h-3 bg-gray-300 rounded w-full" />
              <div class="h-3 bg-gray-300 rounded w-11/12 mt-2" />
              <div class="h-3 bg-gray-300 rounded w-10/12 mt-2" />
            </div>
          </div>
        </div>
      </tw-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import PublisherBase from "@/mixins/Publisher/PublisherBase";
import TwCard from "@/components/Tailwind/TwCard.vue";

export default {
  name: "ExternalAdUnitMediaAlpha",
  components: {TwCard},
  mixins: [
    PublisherBase
  ],
  props: {
    ...PublisherBase.props,
    containerId: {
      type: String,
      default: "mediaalpha_container"
    },
    noDescriptionToggle: {
      type: Boolean,
      default: false
    },
    numAds: {
      type: [String,Number],
      default: 0
    }
  },
  data() {
    return {
      id: 27,
      loading: true,
      // eventsSearchData: {}
    };
  },
  computed: {},
  mounted() {},
  methods: {
    componentInit() {
      return new Promise((resolve) => {
        this.domElement.searchData = this.domElement.searchData ?? {
          zip: (this.visitorLocation.postalCode.length > 0 ? this.visitorLocation.postalCode : "auto")
        };

        // Configure standardized search data object that can be passed w/ events
        this.eventsSearchData = {
          postal_code: typeof this.domElement.searchData.zip !== "undefined" ? this.domElement.searchData.zip : null,
          currently_insured: typeof this.domElement.searchData.currently_insured !== "undefined" ? this.domElement.searchData.currently_insured : null,
          current_insurer: typeof this.domElement.searchData.current_company !== "undefined" ? this.domElement.searchData.current_company : null,
          own_home: typeof this.domElement.searchData.home_ownership !== "undefined" ? this.domElement.searchData.home_ownership : null,
          num_drivers: typeof this.domElement.searchData.drivers !== "undefined" ? this.domElement.searchData.drivers.length : null,
          own_multiple_vehicles: typeof this.domElement.searchData.vehicles !== "undefined" ? (this.domElement.searchData.vehicles.length > 1 ? 1 : 0) : null,
          first_name: typeof this.domElement.searchData.contact !== "undefined" && this.domElement.searchData.contact.length > 0 ? this.domElement.searchData.contact.split(" ")[0] : null,
          last_name: typeof this.domElement.searchData.contact !== "undefined" && this.domElement.searchData.contact.length > 0 ? this.domElement.searchData.contact.replace(/ +(?= )/g,'').split(" ")[1] : null,
          email: typeof this.domElement.searchData.email !== "undefined" && this.domElement.searchData.email.length > 0 ? this.domElement.searchData.email : null,
          phone: typeof this.domElement.searchData.phone !== "undefined" ? this.domElement.searchData.phone.replace(/\D/g, '') : null,
          bundle_home_auto: typeof this.domElement.searchData.interested_in_home_insurance !== "undefined" ? this.domElement.searchData.interested_in_home_insurance : null,
          num_incidents: typeof this.domElement.searchData.incidents !== "undefined" ? this.domElement.searchData.incidents.length : null,
          pii: null
        };
        if (this.domElement.searchData.drivers !== "undefined") {
          let now = new Date();
          let birthDate = new Date(this.domElement.searchData.drivers[0].birth_date);
          let diffInMs = Math.abs(now.getTime() - birthDate.getTime());
          let diffInYears = diffInMs / (1000 * 60 * 60 * 24 * 365.25);
          this.eventsSearchData.age = Math.floor(diffInYears);
        }
        if ( this.eventsSearchData.first_name !== null && this.eventsSearchData.first_name.length > 0
            || this.eventsSearchData.last_name !== null && this.eventsSearchData.last_name.length > 0
            || this.eventsSearchData.email !== null
            || this.eventsSearchData.phone !== null) {
          this.eventsSearchData.pii = 1;
        }

        if (typeof MediaAlphaExchange__load === "function") {
          this.loadMediaAlphaAdUnit();
        }
        else {
          let s = document.createElement("script");
          s.src = this.urlParams.get("matest") == 1 ? "https://insurance-test.mediaalpha.com/js/serve.js" : "https://insurance.mediaalpha.com/js/serve.js";
          s.type = "text/javascript";
          s.async = false;
          document.getElementsByTagName('head')[0].appendChild(s);

          this.waitForMediaAlphaScriptLoaded(() => {
            this.loadMediaAlphaAdUnit();
          }, 50, 8000);
        }

        resolve();
      });
    },
    loadMediaAlphaAdUnit() {
      let s = document.createElement("script");

      let placementId = "s9-gOHdWB07qOrnUKrAy4IKlrVRxdw";
      if (this.urlParams.get("manpl") == 1) {
        placementId = "zU0rBKPoIITdu_sKV8J5pjVmTnAGJw";
      }

      s.innerText = 'var MediaAlphaExchange = ' + JSON.stringify({
        data: this.domElement.searchData,
        placement_id: placementId,
        type: "ad_unit",
        version: 17,
        sub_1: this.publisherEventData.publisher_channel_1,
        sub_2: this.publisherEventData.publisher_channel_3,
        sub_3: window.jfp.visitorId
      }) + ';';
      s.type = "text/javascript";
      document.getElementsByTagName('head')[0].appendChild(s);

      MediaAlphaExchange__load(this.containerId);

      this.waitForElementToDisplay("#" + this.containerId + " .mav-partner", () => {

        this.jfpTrack("ContentView", {
          advertiser_account_id: 1022,
          search_data: this.eventsSearchData
        });

        let maContainer = document.getElementById(this.containerId);
        let maRows = maContainer.getElementsByClassName("mav-partner");
        for (let i = 0; i < maRows.length; i++) {
          let thisMaRow = maRows.item(i);

          if (this.numAds > 0) {
            if (i >= this.numAds) {
              thisMaRow.style.display = "none";
            }
          }

          // TODO: Keep or remove this?
          if (typeof this.domElement.searchData.current_company !== "undefined" && maRows.length > 1) {
            if (thisMaRow.dataset.carrier == this.domElement.searchData.current_company) {
              thisMaRow.style.display = "none";
            }
          }

          if (this.noDescriptionToggle) {
            let thisDescriptionElement = thisMaRow.getElementsByClassName("mav-partner__description")[0];
            thisDescriptionElement.style.setProperty("max-height", "min-content", "important")
          }

          // Add click event listeners
          thisMaRow.addEventListener("click", () => {
            this.$emit("content-click", {
              ...this.publisherEventData,
              ...{
                advertiser_account_id: 1022,
                event_value: 1
              }
            });
          });
        }

        this.loading = false;
        this.$emit("ads-loaded");

      },100,20000);
    },
    waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
      let startTimeInMs = Date.now();
      let vm = this;
      (function loopSearch() {
        if (document.querySelector(selector) != null) {
          callback();
        }
        else {
          setTimeout(function () {
            if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) {
              vm.triggerNoContentLoaded({
                advertiser_account_id: 1022,
                search_data: vm.eventsSearchData
              });
              return;
            }
            loopSearch();
          }, checkFrequencyInMs);
        }
      })();
    },
    waitForMediaAlphaScriptLoaded(callback, checkFrequencyInMs, timeoutInMs) {
      let startTimeInMs = Date.now();
      let vm = this;
      (function fnLoopSearch() {
        if (typeof MediaAlphaExchange__load === "function") {
          callback();
        }
        else {
          setTimeout(function () {
            if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) {
              vm.triggerNoContentLoaded({
                advertiser_account_id: 1022,
                search_data: vm.eventsSearchData
              });
              return;
            }
            fnLoopSearch();
          }, checkFrequencyInMs);
        }
      })();
    }
  }
}
</script>

<style src="@/styles/index.css" />
<style>
.mediaalpha-container {
  > div:first-of-type {
    padding: 0 !important;
  }

  &.--no-description-toggle {
    .mav-partner__collapse-toggle {
      display: none !important;
    }
  }
}
</style>